import {
  Component,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChild,
  ViewChildren
} from "@angular/core";
import {InnerSectionComponent} from '../inner-section/inner-section.component';
import {DynamicFormComponent} from '../dynamic-form/dynamic-form.component';
import {CommonModule} from '@angular/common';
import {MatStepperModule} from '@angular/material/stepper';
import {MatButtonModule} from '@angular/material/button';
import {MatExpansionModule, MatExpansionPanel} from '@angular/material/expansion';
import {FormGroup} from '@angular/forms';
import {ApplicationFormComponent} from '../application-form/application-form.component';
import {StepResource} from "../../core/modules/openapi";

@Component({
  selector: 'app-dynamic-step',
  imports: [MatExpansionModule, InnerSectionComponent, DynamicFormComponent, CommonModule, MatStepperModule, MatButtonModule],
  templateUrl: './dynamic-step.component.html',
  standalone: true,
  styleUrl: './dynamic-step.component.sass'
})
export class DynamicStepComponent {
  @Input() step: StepResource;
  @Input() sequence: number = 0;
  @Input() title: String = '';
  @Input() previousStep: StepResource;
  @Input() parent: ApplicationFormComponent;
  @Output() submit: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild(DynamicFormComponent, { static: false }) dynamicForm: DynamicFormComponent;
  @ViewChild(MatExpansionPanel, { static: false }) panel: MatExpansionPanel;
  @ViewChildren('innerSection') innerSections: QueryList<InnerSectionComponent>;

  form: FormGroup = new FormGroup({});

  constructor() { }

  ngOnInit() {
  }

  onSubmit(value: any) {
    let isFormValid = true;
    isFormValid = this.parent.form.valid;

    if (!isFormValid) {
      this.parent.validateAllFormFields(this.parent.form);
    }

    if (this.dynamicForm) {
      isFormValid = isFormValid && this.dynamicForm.form.valid;
      if (!isFormValid) {
        this.dynamicForm.validateFormFields();
      }
    }

    if (this.innerSections != null) {
      this.innerSections.forEach(section => {
        let isSectionValid;
        if (section.dynamicForm.form.enabled) {
          isSectionValid = section.dynamicForm.form.valid;
        } else {
          isSectionValid = true;
        }
        section.valid = isSectionValid;
        isFormValid = isFormValid && isSectionValid;
        if (!isFormValid) {
          section.dynamicForm.validateFormFields();
        }
      });
    }

    if (isFormValid) {
      this.parent.moveToDone(value, this.sequence);
    } else {
      this.dynamicForm.enableSubmit(undefined);
    }
  }

  public getFormValue() {
    let formValue;
    let dfValue;
    let innerSectionValues: any;
    if (this.dynamicForm) {
      dfValue = this.dynamicForm.value;
    }

    if (this.innerSections != null) {
      this.innerSections.forEach(section => {
        innerSectionValues = { ...innerSectionValues, ...section.dynamicForm.value };
      });
    }
    formValue = { ...dfValue, ...innerSectionValues };
    return formValue;
  }

  public getFormFormattedValue() {
    let formValue = [];
    if (this.dynamicForm) {
      formValue.push(...this.formatFormValue(this.dynamicForm));
    }

    if (this.innerSections != null) {
      this.innerSections.forEach(section => {
        formValue.push(...this.formatFormValue(section.dynamicForm));
      });
    }
    return formValue;
  }

  private formatFormValue(form: DynamicFormComponent) {
    let filledFormVal = form.value;
    let jsonArr = form.fields;
    let resultArray: Record<"displayName", unknown>[] = [];
    jsonArr.forEach(element => {
      let dict = {
        displayName: '',
        name: '',
        value: ''
      };
      if (element.displayName && !(element.displayName === 'Submit')) {
        dict['displayName'] = element.displayName;
      }

      dict['name'] = element['name'] || '';
      let value;
      if (!element.enabled) {
        value = element.value;
      } else if (element.name) {
        value = filledFormVal[element.name];
      }

      if (Array.isArray(value)) {
        value = value.toString()
      } else if (typeof value == "object") {
        value = JSON.stringify(value);
      }
      dict['value'] = value
      if ('displayName' in dict)
        resultArray.push(dict)
    })

    return resultArray
  }
}
